import { render } from "./addEvaLesson.vue?vue&type=template&id=497aec0e&scoped=true"
import script from "./addEvaLesson.vue?vue&type=script&lang=js"
export * from "./addEvaLesson.vue?vue&type=script&lang=js"

import "./addEvaLesson.vue?vue&type=style&index=0&id=497aec0e&scoped=true&lang=css"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-497aec0e"]])

export default __exports__